import { Module } from 'wrapper6'
import ObjectFitClass from '../utils/_object-fit'

const $ = jQuery

export default class Filters extends Module {
  ready (app) {
    /********************************************
     * SHARED VARS
     ********************************************/

    const LOADER = $('#loader')

    /*
    ***
    ******* News filter loop
    ***
    */

    // Consts

    const NEWS_FILTER = '#news-filter'
    const NEWS_AREAS = '#news-areas'
    const NEWS_TOGGLE_CONTAINER = $('.mtt-posts-filter.news .page_container')
    const NEWS_DESTINATION = $('.mtt-posts-filter.news .mtt-posts-filter__posts')
    const NEWS_PAGINATION = '.mtt-posts-filter.news #posts-pagination ul li a'
    const NEWS_PAGINATION_DEST = $('.mtt-posts-filter.news #posts-pagination')

    // Lets

    let news_cat = ''
    let news_area = ''
    let news_page_number = 0

    // Filter news posts
    $('.mtt-posts-filter').on('change', NEWS_FILTER, function () {
      news_cat = $(this).find(':selected').val()

      news_page_number = 0

      getNews()
    })

    // Filter news posts
    $('.mtt-posts-filter').on('change', NEWS_AREAS, function () {
      news_area = $(this).find(':selected').val()

      news_page_number = 0

      getNews()
    })

    // Click on pagination
    $(document).on('click', NEWS_PAGINATION, function (e) {
      // Prevent default link behavior
      e.preventDefault()

      // Update page number
      news_page_number = $(this).attr('data-page')

      // Run ajax request
      getNews()
    })

    // Ajax request function
    function getNews () {
      // Show loader
      LOADER.addClass('show')

      // Animate body to top
      if ($(window).width() > 600) {
        $('html, body').animate({
          scrollTop: NEWS_TOGGLE_CONTAINER.offset().top - 150
        }, 500)
      } else {
        $('html, body').animate({
          scrollTop: NEWS_DESTINATION.offset().top - 60
        }, 500)
      }

      // Set ajax data
      const data = {
        action: 'filter_news',
        cat: news_cat,
        area: news_area,
        page_number: news_page_number,
        url: window.location.href
      }

      // Ajax call
      jQuery.post(main_theme_objects.ajax_url, data, function (response) {
        if (response != 0) {
          // Post response
          if (response.posts !== '') {
            NEWS_DESTINATION.html(response.posts)
            NEWS_DESTINATION.append('<div class="filler"> </div>')
            NEWS_DESTINATION.append('<div class="filler"> </div>')
          } else {
            NEWS_DESTINATION.html('<p class="no-posts">' + NEWS_DESTINATION.attr('data-no-posts') + '</p>')
          }

          new ObjectFitClass()

          // Pagination response
          NEWS_PAGINATION_DEST.html(response.pagination)

          // Hide loader
          LOADER.removeClass('show')
        }
      })
    }

    /*
    ***
    ******* Cases filter loop
    ***
    */

    // Consts

    const CASES_FILTER = '#cases-filter'
    const CASES_TOGGLE_CONTAINER = $('.mtt-posts-filter.cases .page_container')
    const CASES_DESTINATION = $('.mtt-posts-filter.cases .mtt-posts-filter__posts')
    const CASES_PAGINATION = '.mtt-posts-filter.cases #posts-pagination ul li a'
    const CASES_PAGINATION_DEST = $('.mtt-posts-filter.cases #posts-pagination')

    // Lets

    let cases_cat = ''
    let cases_page_number = 0

    // Filter news posts
    $('.mtt-posts-filter').on('change', CASES_FILTER, function () {
      cases_cat = $(this).find(':selected').val()

      cases_page_number = 0

      getCases()
    })

    // Click on pagination
    $(document).on('click', CASES_PAGINATION, function (e) {
      // Prevent default link behavior
      e.preventDefault()

      // Update page number
      cases_page_number = $(this).attr('data-page')

      // Run ajax request
      getCases()
    })

    // Ajax request function
    function getCases () {
      // Show loader
      LOADER.addClass('show')

      // Animate body to top
      if ($(window).width() > 600) {
        $('html, body').animate({
          scrollTop: CASES_TOGGLE_CONTAINER.offset().top - 150
        }, 500)
      } else {
        $('html, body').animate({
          scrollTop: CASES_DESTINATION.offset().top - 60
        }, 500)
      }

      // Set ajax data
      const data = {
        action: 'filter_cases',
        cat: cases_cat,
        page_number: cases_page_number,
        url: window.location.href
      }

      // Ajax call
      jQuery.post(main_theme_objects.ajax_url, data, function (response) {
        if (response != 0) {
          // Post response
          if (response.posts !== '') {
            CASES_DESTINATION.html(response.posts)
            CASES_DESTINATION.append('<div class="filler"> </div>')
            CASES_DESTINATION.append('<div class="filler"> </div>')
          } else {
            CASES_DESTINATION.html('<p class="no-posts">' + CASES_DESTINATION.attr('data-no-posts') + '</p>')
          }

          new ObjectFitClass()

          // Pagination response
          CASES_PAGINATION_DEST.html(response.pagination)

          // Hide loader
          LOADER.removeClass('show')
        }
      })
    }

    /*
    ***
    ******* Used Products filter
    ***
    */

    // Consts

    const PRODUCTS_FILTER = '#used_product-filter'
    const PRODUCTS_TOGGLE_CONTAINER = $('.mtt-posts-filter.used_product .page_container')
    const PRODUCTS_DESTINATION = $('.mtt-posts-filter.used_product .mtt-posts-filter__posts')
    const PRODUCTS_PAGINATION = '.mtt-posts-filter.used_product #posts-pagination ul li a'
    const PRODUCTS_PAGINATION_DEST = $('.mtt-posts-filter.used_product #posts-pagination')

    // Lets

    let products_cat = ''
    let products_page_number = 0

    // Filter news posts
    $('.mtt-posts-filter.used_product').on('change', PRODUCTS_FILTER, function () {
      products_cat = $(this).find(':selected').val()

      products_page_number = 0

      getUsedProducts()
    })

    // Click on pagination
    $(document).on('click', PRODUCTS_PAGINATION, function (e) {
      // Prevent default link behavior
      e.preventDefault()

      // Update page number
      products_page_number = $(this).attr('data-page')

      // Run ajax request
      getUsedProducts()
    })

    // Ajax request function
    function getUsedProducts () {
      // Show loader
      LOADER.addClass('show')

      // Animate body to top
      if ($(window).width() > 600) {
        $('html, body').animate({
          scrollTop: PRODUCTS_TOGGLE_CONTAINER.offset().top - 150
        }, 500)
      } else {
        $('html, body').animate({
          scrollTop: PRODUCTS_DESTINATION.offset().top - 60
        }, 500)
      }

      // Set ajax data
      const data = {
        action: 'filter_used_products',
        cat: products_cat,
        page_number: products_page_number,
        url: window.location.href
      }

      // Ajax call
      jQuery.post(main_theme_objects.ajax_url, data, function (response) {
        if (response != 0) {
          // Post response
          if (response.posts !== '') {
            PRODUCTS_DESTINATION.html(response.posts)
            PRODUCTS_DESTINATION.append('<div class="filler"> </div>')
            PRODUCTS_DESTINATION.append('<div class="filler"> </div>')
          } else {
            PRODUCTS_DESTINATION.html('<p class="no-posts">' + PRODUCTS_DESTINATION.attr('data-no-posts') + '</p>')
          }

          new ObjectFitClass()

          // Pagination response
          PRODUCTS_PAGINATION_DEST.html(response.pagination)

          // Hide loader
          LOADER.removeClass('show')
        }
      })
    }

    /*
    ***
    ******* New Products filter
    ***
    */

    // Consts

    const NEW_PRODUCTS_FILTER = '#new_product-filter'
    const NEW_PRODUCTS_TOGGLE_CONTAINER = $('.mtt-posts-filter.new_product .page_container')
    const NEW_PRODUCTS_DESTINATION = $('.mtt-posts-filter.new_product .mtt-posts-filter__posts')
    const NEW_PRODUCTS_PAGINATION = '.mtt-posts-filter.new_product #posts-pagination ul li a'
    const NEW_PRODUCTS_PAGINATION_DEST = $('.mtt-posts-filter.new_product #posts-pagination')

    // Lets

    let new_products_cat = ''
    let new_products_page_number = 0

    // Filter news posts
    $('.mtt-posts-filter.new_product').on('change', NEW_PRODUCTS_FILTER, function () {
      new_products_cat = $(this).find(':selected').val()

      new_products_page_number = 0

      getNewProducts()
    })

    // Click on pagination
    $(document).on('click', NEW_PRODUCTS_PAGINATION, function (e) {
      // Prevent default link behavior
      e.preventDefault()

      // Update page number
      new_products_page_number = $(this).attr('data-page')

      // Run ajax request
      getNewProducts()
    })

    // Ajax request function
    function getNewProducts () {
      // Show loader
      LOADER.addClass('show')

      // Animate body to top
      if ($(window).width() > 600) {
        $('html, body').animate({
          scrollTop: NEW_PRODUCTS_TOGGLE_CONTAINER.offset().top - 150
        }, 500)
      } else {
        $('html, body').animate({
          scrollTop: NEW_PRODUCTS_DESTINATION.offset().top - 60
        }, 500)
      }

      // Set ajax data
      const data = {
        action: 'filter_new_products',
        cat: new_products_cat,
        page_number: new_products_page_number,
        url: window.location.href
      }

      // Ajax call
      jQuery.post(main_theme_objects.ajax_url, data, function (response) {
        if (response != 0) {
          if (response.posts !== '') {
            NEW_PRODUCTS_DESTINATION.html(response.posts)
            NEW_PRODUCTS_DESTINATION.append('<div class="filler"> </div>')
            NEW_PRODUCTS_DESTINATION.append('<div class="filler"> </div>')
          } else {
            NEW_PRODUCTS_DESTINATION.html('<p class="no-posts">' + NEW_PRODUCTS_DESTINATION.attr('data-no-posts') + '</p>')
          }

          new ObjectFitClass()

          // Pagination response
          NEW_PRODUCTS_PAGINATION_DEST.html(response.pagination)

          // Hide loader
          LOADER.removeClass('show')
        }
      })
    }

    /*
    ***
    ******* Solutions filter
    ***
    */

    // Consts

    const SOLUTIONS_FILTER = '#solution-filter'
    const SOLUTIONS_TOGGLE_CONTAINER = $('.mtt-posts-filter.solution .page_container')
    const SOLUTIONS_DESTINATION = $('.mtt-posts-filter.solution .mtt-posts-filter__posts')
    const SOLUTIONS_PAGINATION = '.mtt-posts-filter.solution #posts-pagination ul li a'
    const SOLUTIONS_PAGINATION_DEST = $('.mtt-posts-filter.solution #posts-pagination')

    // Lets

    let solution_cat = ''
    let solution_page_number = 0

    // Filter news posts
    $('.mtt-posts-filter').on('change', SOLUTIONS_FILTER, function () {
      solution_cat = $(this).find(':selected').val()

      solution_page_number = 0

      getSolutions()
    })

    // Click on pagination
    $(document).on('click', SOLUTIONS_PAGINATION, function (e) {
      // Prevent default link behavior
      e.preventDefault()

      // Update page number
      solution_page_number = $(this).attr('data-page')

      // Run ajax request
      getSolutions()
    })

    // Ajax request function
    function getSolutions () {
      // Show loader
      LOADER.addClass('show')

      // Animate body to top
      if ($(window).width() > 600) {
        $('html, body').animate({
          scrollTop: SOLUTIONS_TOGGLE_CONTAINER.offset().top - 150
        }, 500)
      } else {
        $('html, body').animate({
          scrollTop: SOLUTIONS_DESTINATION.offset().top - 60
        }, 500)
      }

      // Set ajax data
      const data = {
        action: 'filter_solutions',
        cat: solution_cat,
        page_number: solution_page_number,
        url: window.location.href
      }

      // Ajax call
      jQuery.post(main_theme_objects.ajax_url, data, function (response) {
        if (response != 0) {
          // Post response
          if (response.posts !== '') {
            SOLUTIONS_DESTINATION.html(response.posts)
            SOLUTIONS_DESTINATION.append('<div class="filler"> </div>')
            SOLUTIONS_DESTINATION.append('<div class="filler"> </div>')
          } else {
            SOLUTIONS_DESTINATION.html('<p class="no-posts">' + SOLUTIONS_DESTINATION.attr('data-no-posts') + '</p>')
          }

          new ObjectFitClass()

          // Pagination response
          SOLUTIONS_PAGINATION_DEST.html(response.pagination)

          // Hide loader
          LOADER.removeClass('show')
        }
      })
    }
  }
}
